module.exports = __webpack_public_path__ + "static/media/flyer2-bg.c905c66b.png";